import "./vendor.ts";

import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { WebAppNotificationModule } from "./notification/notification.module";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserIdleModule } from 'angular-user-idle';
import {
  ConfigService,
  ConfigModule
} from "src/assets/environments/ConfigService";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { RootComponent } from "./app-root/app-root.component";
// import { MainComponent } from "./Layout/main/main.component";
import { InvoiceListComponent } from "./entities/invoices/invoice-list/invoice-list.component";
import { GuidComponent } from "./entities/guid/guid.component";
import { AppComponent } from "./app.component";
import { PageDownloadComponent } from "./entities/page-download/page-download.component";

import { LoginLayoutComponent } from "./Layout/template/login-layout.component";
import { HomeLayoutComponent } from "./Layout/template/home-layout.component";
import { ItemChangePasswordComponent } from "./entities/change-password/item.component";
import { ItemForgotPasswordComponent } from "./entities/forgot-password/item.component";
import { InvoiceCheckComponent } from "./entities/invoiceCheck/invoice-check.component";
import { ItemService } from "./entities/invoiceCheck/invoiceCheck.service";
import { ItemService as InvoiceService } from "./entities/invoice-created/item.service";
import { ItemService as ItemServiceInvoice } from "./entities/invoice-management/item.service";
import { Announcementservice } from "./entities//announcement/Announcement.service";

import { AuthService } from "./entities/auth/auth.service";
import { LoginService } from "./entities/login/login.service";
import { SystemSettingStorageService } from "./shared/model/system-setting-storage.service";
import { LocalStorageService } from "ng2-webstorage";
import { PermissionService } from "./shared/utils/permissions.service";
import { AuthServerProvider } from "./shared";
import { CompanyService } from "./shared/services/company/company.service";
import { FormatNumberInputProvider } from "./shared/components/format-number-input/format-number-input.component";
import { MoneyFormatPipe } from "./shared/pipes/money-format.pipe";
import { DatePipe } from "@angular/common";
// import { TranslateStore } from "@ngx-translate/core/src/translate.store";
import { HttpModule } from "@angular/http";
// import { JhiPaginationUtil } from 'ng-jhipster';
import { Invoices as InvoicesService } from "./entities/invoices/invoices.service";
// import { JhiEventManager } from 'ng-jhipster';
import { WebAppItemModule as WebAppInvoiceReviewModule } from "./entities/invoice-html/item.module";
import { MWebAppAnnouncementModule } from "./entities/announcement/Announcement.module";
import { WebAppItemModule as WebAppClientManagementModule } from "./entities/client-management/item.module";
import { VideoTutorialModule } from "./entities/video-tutorial/video-tutorial.module";
import { WebAppItemChangePasswordModule } from "./entities/change-password/item.module";
import { WebAppItemForgotPasswordModule } from "./entities/forgot-password/item.module";
import { MainModule } from "./Layout/main/item.module";
import { TranslatePipeModule } from "../language/language.module";
import { LoginModule } from "./entities/login/login.module";
import {
  AnnouncementRoute,
  AnnouncementEditResolvePagingParams,
  AnnouncementResolvePagingParams
} from "./entities/announcement/Announcement.route";
import { PopupService } from "./shared/services/popup/popup.service";


import { AuthInterceptor } from './blocks/interceptor/auth.interceptor.js';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    WebAppNotificationModule,
    HttpClientModule,
    HttpModule,
    AppRoutingModule,
    WebAppInvoiceReviewModule,
    LoginModule,
    MWebAppAnnouncementModule,
    WebAppClientManagementModule,
    MainModule,
    VideoTutorialModule,
    WebAppItemChangePasswordModule,
    WebAppItemForgotPasswordModule,
    TranslatePipeModule,
    UserIdleModule.forRoot({idle: 1200, timeout: 2, ping: 120}),
    NgbModule.forRoot()
  ],
  declarations: [
    RootComponent,
    // MainComponent,
    HomeLayoutComponent,
    GuidComponent,
    PageDownloadComponent,
    LoginLayoutComponent,
    ItemChangePasswordComponent,
    ItemForgotPasswordComponent,
    InvoiceCheckComponent,
    InvoiceListComponent,
    AppComponent
  ],

  entryComponents: [InvoiceListComponent],

  providers: [
    ConfigService,
    ConfigModule.init(),
    ItemService,
    PopupService,
    InvoiceService,
    ItemServiceInvoice,
    Announcementservice,
    AnnouncementEditResolvePagingParams,
    AnnouncementResolvePagingParams,
    SystemSettingStorageService,
    LocalStorageService,
    PermissionService,
    AuthServerProvider,
    CompanyService,
    FormatNumberInputProvider,
    MoneyFormatPipe,
    DatePipe,
    // TranslateStore,
    // JhiPaginationUtil,
    NgbActiveModal,
    InvoicesService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
    // JhiEventManager,
    // NgbModalRef,
  ],
  bootstrap: [RootComponent]
})
export class AppModule {}
